var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Invoices animated fadeIn"},[_c('MuiGridContainer',{staticClass:"TemplateDefault__container",attrs:{"fluid":false}},[_vm._v("\n    Invoices Page\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }